export const AUTH0_CLIENT_ID = 'ykO8WMtlGFlDfl7FCPY5wcDEJaPXQ6Oa';
export const AUTH0_DOMAIN = 'everymundo.auth0.com';
export const AUTH0_CALLBACK_URL = location.origin + '/logincallback';
// NOTE: Domains to attach the auth0 token
export const AUTH0_WHITE_LIST = [
    /^.+\.everymundo\.(com|io)$/i,
    /^.+\.airtrfx\.com$/i,
    /^.+\.amazonaws\.com$/i
];
